import { parseUnfInvoice, pdfTextToRows, type ParsedUnfInvoice } from '@crm/shared'
import { loadPdfText } from '../../../shared/utils/loadPdfText'
import { loadXlsx } from '../../../shared/utils/loadXlsx'

/**
 * Читает счёт, выгруженный из 1С, и разбирает его: Excel — первый лист книги,
 * PDF (с 21.10.2026) — текст всех страниц, разложенный в строки как в Excel.
 */
export async function readUnfInvoiceFile(file: File): Promise<ParsedUnfInvoice> {
  const data = await file.arrayBuffer()
  if (/\.pdf$/i.test(file.name) || file.type === 'application/pdf') {
    const items = await loadPdfText(data)
    if (items.length === 0) {
      throw new Error('В PDF нет текста (похоже на скан) — сохраните счёт из 1С в PDF или Excel')
    }
    return parseUnfInvoice(pdfTextToRows(items))
  }
  const XLSX = await loadXlsx()
  const book = XLSX.read(data, { type: 'array' })
  const sheet = book.Sheets[book.SheetNames[0] ?? '']
  if (!sheet) throw new Error('В файле нет листов')
  return parseUnfInvoice(XLSX.utils.sheet_to_json(sheet, { header: 1, raw: true, defval: null }))
}
